import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
export type DeactivateUserMutationVariables = GraphQLTypes.Exact<{
  deactivateUser: GraphQLTypes.Scalars['String']['input'];
}>;

export type DeactivateUserMutationResult = { __typename?: 'Mutation' } & {
  deactivateUser?: GraphQLTypes.Maybe<
    { __typename?: 'DeactivateUserPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message'>>>;
    }
  >;
};

export const DeactivateUserDocument = gql`
  mutation deactivateUser($deactivateUser: String!) {
    deactivateUser(userId: $deactivateUser) {
      errors {
        message
      }
    }
  }
`;
